module.exports = __webpack_public_path__ + "img/binghatti-2.64984fd.webp";